import React from "react";
import "./scss/AffiliateNoResults.scss";

function AffiliateNoResultFilter() {
    return (
        <div className="affiliate-no-results" id="affiliate-no-results-dt">
            <div className="affiliate-no-results-img"></div>
            <div className="affiliate-no-results-text">
                <div className="affiliate-no-results-text-sorry">No results found matching your selection.</div>
            </div>
        </div>
    );
}

export default AffiliateNoResultFilter;
